import { useMutation } from "react-query";
import { APIFetchStudioV2, RequestHeaders } from "@certa/network";
import type { UseMutationExtraConfigType } from "@certa/common/types";
import { z } from "zod";

// Allowed values for statuses
const updateBranchStatusSchema = z.enum(["frozen", "archived"]);
type UpdateBranchStatus = z.infer<typeof updateBranchStatusSchema>;

export type UpdateBranchRequest = {
  branchId: number;
  name?: string;
  status?: UpdateBranchStatus;
};

function updateBranch(payload: UpdateBranchRequest): Promise<void> {
  const requestBody: {
    name?: string;
    status?: string;
  } = {};

  if (payload.name !== undefined) {
    requestBody.name = payload.name;
  }

  if (payload.status !== undefined) {
    requestBody.status = payload.status;
  }

  const requestOptions: RequestInit = {
    method: "PATCH",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify(requestBody)
  };

  return APIFetchStudioV2<void>(
    `branch/${payload.branchId}/update/`,
    requestOptions
  );
}

export const useUpdateBranchMutation = (
  extraConfig?: UseMutationExtraConfigType
) => useMutation(updateBranch, extraConfig);
